module.exports = __webpack_public_path__ + "media/site/images/case_studies/ekanban/solution1_1@2x-47ef899a319bec34b416255fa81565eb.png";